import type { EditPatScoreSubmission } from "@/pages/events/[eventSlug]/(tabbed)/results/_components/EditScoreModal";

export type PatScoreEditRow = {
  id?: string;
  patType?: string;
  slug?: string | null;
  rawDate?: string;
  additionalStatus?: string | null;
  note?: string | null;
  roundOneScore?: number | null;
  roundTwoScore?: number | null;
  totalScore?: number | null;
  targetScore?: number | null;
  suspension?: {
    startDate: string;
    endDate: string | null;
  } | null;
};

const SYNTHETIC_PAT_SUBMISSION_ID_PREFIX = "pat-submission-";

export const canOpenPatScoreEditor = (row: PatScoreEditRow): boolean => {
  if (row.patType !== "standard_pat") return false;
  if (!row.id || row.id.startsWith(SYNTHETIC_PAT_SUBMISSION_ID_PREFIX)) return false;
  if (!row.slug) return false;
  if (!row.rawDate) return false;
  return new Date(row.rawDate) <= new Date();
};

export const findPatEventRegistrationId = (
  registrations: Array<{
    id: string;
    canceledAt?: string | null;
    event?: { slug?: string | null } | null;
  }>,
  slug: string
): string | null => {
  const matches = registrations.filter((registration) => registration.event?.slug === slug);
  return (matches.find((registration) => !registration.canceledAt) ?? matches[0])?.id ?? null;
};

export const findPatEventRegistrantId = (
  registrants: Array<{ id: string; pgaId?: string | null }>,
  pgaId: string
): string | null => registrants.find((registrant) => registrant.pgaId === pgaId)?.id ?? null;

export const mapPatActivityRowToEditScoreSubmission = (
  row: PatScoreEditRow,
  eventRegistrationId: string
): EditPatScoreSubmission => ({
  id: eventRegistrationId,
  attended: row.additionalStatus !== "no_show",
  note: row.note ?? "",
  score_18_1: row.roundOneScore == null ? "" : String(row.roundOneScore),
  score_18_2: row.roundTwoScore == null ? "" : String(row.roundTwoScore),
  score_total: row.totalScore ?? null,
  score_target: row.targetScore ?? null,
  additionalStatus: row.additionalStatus ?? "",
  date: row.rawDate || "",
  suspension: row.suspension ?? null
});
